import React, { Component } from 'react';
import Modal from 'react-modal';
import ControlCv from './ControlCv';
import ControlMessageNew from './ControlMessageNew';
import { getTranslation } from '../../../Utilities/GetTranslation';
import { getFaseText, getCreateMsgTitle } from '../../../Utilities/SnsExtranetFunctions';
import { getDateString, getJsonDate } from '../../../Utilities/JsonFunctions';

declare var globalSns;

class ControlCandidateFicheProject extends Component {
    constructor(props) {
        super(props);

        this.state = {};

        this.openMessageBox = this.openMessageBox.bind(this);
        this.closeMessageBox = this.closeMessageBox.bind(this);
    }

    openMessageBox() {
        this.setState({openMessageBox: true});
    }

    closeMessageBox() {
        this.setState({openMessageBox: false});
    }

    render() {
        return (
            <div className="projectbadge">
                <i className="fa fa-briefcase" aria-hidden="true"></i>
                <h3><a className="subcatlink" onClick={() => this.props.onNavigateToProjects()}>{this.props.project.title}</a></h3>
                <div className="EditingFormTable table compact">
                    {
                        (this.props.project.showOnlineCv) ?
                            <div className="tr">
                                <div className="FieldLabel td">{getTranslation("sns.general.extranet.onlinecvform")}</div>
                                <div className="EditingFormValueCell td">
                                    <ControlCv candidateId={this.props.candidateId} jobId={this.props.project.id} />
                                </div>
                            </div> : ""
                    }
                    <div className="tr">
                        <div className="FieldLabel td">{getTranslation("sns.general.extranet.documents")}</div>
                        <div className="EditingFormValueCell td">
                            <p className="form-control-static">
                                <a className="subcatlink" onClick={(e) => this.props.onNavigateToDocuments()}><span className="alignnumeric">{this.props.project.nrDocuments}</span> <i className="fa fa-paperclip" aria-hidden="true"></i></a>
                            </p>                            
                        </div>
                    </div>
                    <div className="tr">
                        <div className="FieldLabel td">{getTranslation("sns.general.extranet.messages")}</div>
                        <div className="EditingFormValueCell td">
                            <p className="form-control-static">
                                <a className="subcatlink" onClick={(e) => this.props.onNavigateToMessages()}><span className="alignnumeric">{this.props.project.nrMessages}</span> <i className="fa fa-envelope-o" aria-hidden="true"></i></a>
                            </p>                            
                        </div>
                    </div>
                    <div className="tr">
                        <div className="FieldLabel td">{getTranslation("sns.general.extranet.candidate.status")}</div>
                        <div className="EditingFormValueCell td">
                            <p className="form-control-static">
                                <span className={"projectStatus" + this.props.project.projectStatus}>{getFaseText(this.props.project.projectFase)}</span>
                            </p>
                        </div>
                    </div>
                    <div className="tr">
                        <div className="FieldLabel td">{getTranslation("sns.general.extranet.candidate.date")}</div>
                        <div className="EditingFormValueCell td">
                            <p className="form-control-static">
                                {getDateString(getJsonDate(this.props.project.entryDate))}
                            </p>
                        </div>
                    </div>
                    <div className="tr">
                        <div className="feedbackButton">
                            <button type="button" className="FormButton btn btn-primary btn-sm" onClick={this.openMessageBox}>
                                <i className="fa fa-pencil" aria-hidden="true"></i>{getCreateMsgTitle(this.props.candidateId, this.props.project.id)}
                            </button>
                        </div>
                    </div>
                </div>
                <Modal
                    isOpen={this.state.openMessageBox}
                    onRequestClose={this.closeMessageBox}
                    className="ReactModal"
                    overlayClassName="ReactModalOverlay"                    
                >
                    <ControlMessageNew 
                        projectId={this.props.project.id}
                        projectName={this.props.project.title}
                        candidateId={this.props.candidateId}
                        candidateName={this.props.candidateName}
                        onRequestClose={this.closeMessageBox} />
                </Modal>                            
            </div>
        );
    }
}

export default ControlCandidateFicheProject;


// WEBPACK FOOTER //
// ./src/Components/Extranet/Pages/ControlCandidateFicheProject.js